import { z } from 'zod'
import payment from 'payment'
import { clabe } from 'clabe-validator'

export const paymentFieldSchemas = {
  method: z
    .string({ required_error: 'El método es obligatorio', invalid_type_error: 'El método es obligatorio' })
    .trim()
    .min(1, 'El método es obligatorio')
    .refine((value) => value === 'spei' || value === 'card', {
      message: 'Método inválido. Debe ser "spei" o "card"',
    }),
  card_number: ({ last4 } = {}) => {
    const normalizedLast4 = String(last4 ?? '')
      .replace(/\D/g, '')
      .slice(-4)

    return z
      .string()
      .min(1, 'El número de tarjeta es obligatorio')
      .regex(/^\d+$/, 'Solo se permiten dígitos')
      .refine((value) => payment.fns.validateCardNumber(value), {
        message: 'El número de tarjeta no es válido',
      })
      .refine((value) => (normalizedLast4 ? value.endsWith(normalizedLast4) : true), {
        message: `La tarjeta debe terminar en ${normalizedLast4}`,
      })
  },
  clabe: z
    .string()
    .length(18, 'La CLABE debe tener 18 dígitos')
    .regex(/^\d+$/, 'Solo se permiten dígitos')
    .refine((value) => clabe.validate(value).ok, {
      message: 'El número de cuenta CLABE no es válido',
    }),
  bank_id: z.string().min(1, 'El banco es obligatorio'),
  cashout_account_id: z.union([
    z.number().min(1, 'La cuenta para retiro es obligatoria'),
    z.string().min(1, 'La cuenta para retiro es obligatoria'),
  ]),
  bank: z.string().min(1, 'El banco es obligatorio'),
  bank_code: z.string().min(1, 'El código de banco es obligatorio'),
  account: z.string().min(1, 'La cuenta es obligatoria'),
}
